import Api from 'libs/api/index';

class UserServices extends Api {
  constructor() {
    super('user_services');
  }
}

export default UserServices;
